import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { NotificationAction, ProjectAction } from "../actions";
import * as notificationApi from "../api/notification";
import { ACTION_TYPE, NOTICE_TYPES } from "../constants/notificationTypes";
import * as AnnouncementApi from "../api/announcement";
import { SetMessage } from "../assets/errorMessages";

export function* watcherNotifications() {
  yield takeLatest(types.NOTICE_LIST_REQUEST, worker);
  yield takeLatest(types.NOTICE_READ_REQUEST, readWorker);
  yield takeLatest(types.NOTIFICATION_REMOVE_REQUEST, removeWorker);
}

function fetchNotifies(pageNumber) {
  return notificationApi.get(pageNumber);
}

function* worker(action) {
  try {
    const response = yield call(fetchNotifies, action.pageNumber);
    const data = response.data;
    yield put(NotificationAction.setNotificationCount(data.unread_count));
    yield put(ProjectAction.reInitializedPendingList(data.pending_projects));
    yield put(NotificationAction.getListSuccess(data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(NotificationAction.getListFailure(message));
  }
}

function readNotice(id, type, action) {
  if (type === NOTICE_TYPES.ANNOUNCEMENT) {
    return AnnouncementApi.action(id, action);
  } else {
    return notificationApi.action(id, action);
  }
}

function* readWorker(action) {
  try {
    const response = yield call(
      readNotice,
      action.id,
      action.noticeType,
      action.action
    );
    const data = response.data;
    const newSeenStatus =
      action.action === ACTION_TYPE.READ
        ? true
        : action.action === ACTION_TYPE.UNREAD
        ? false
        : null;
    if (newSeenStatus !== null) {
      yield put(NotificationAction.readSuccess(action.id, newSeenStatus));
    }
    yield put(NotificationAction.setNotificationCount(data.data.unread_count));
  } catch (error) {
    SetMessage(error, true);
    const prevSeenStatus =
      action.action === ACTION_TYPE.READ
        ? false
        : action.action === ACTION_TYPE.UNREAD
        ? true
        : null;
    if (prevSeenStatus !== null) {
      yield put(NotificationAction.readFailure(action.id, prevSeenStatus));
    }
  }
}

function removeNotification(id) {
  return notificationApi.action(id, ACTION_TYPE.DELETE);
}

function* removeWorker(action) {
  try {
    const response = yield call(removeNotification, action.id);
    const data = response.data;
    yield put(NotificationAction.setNotificationCount(data.data.unread_count));
    yield put(NotificationAction.removeSuccess(action.id));
  } catch (error) {
    SetMessage(error, true);
    yield put(NotificationAction.removeFailure(action.id));
  }
}
